
const createInfoBulle = (lexiqueResultsSlug, lexiqueRefs, id) => {
  const descDiv = document.getElementById(id);
  lexiqueRefs.forEach((elemRef) => {
    lexiqueResultsSlug.forEach(result => {
      if (result.slug === elemRef.id) {
        const titleTooltip = result.title;
        const contentTooltip = result.lexiconElementDefinition;
        const infoBulle = document.createElement('span');
        const infoTitle = document.createElement('span');
        const infoContent = document.createElement('span');
        const infoPointer = document.createElement('span');
        const infoPointerWrap = document.createElement('span');
        infoBulle.setAttribute('class', 'lexicon-element__text');
        infoTitle.setAttribute('class', 'tooltip-title');
        infoContent.setAttribute('class', 'tooltip-content');
        infoPointer.setAttribute('class', 'info-pointer-wrap__pointer');
        infoPointerWrap.setAttribute('class', 'info-pointer-wrap');
        infoTitle.innerHTML = (titleTooltip);
        infoContent.innerHTML = contentTooltip;
        infoBulle.appendChild(infoTitle);
        infoBulle.appendChild(infoContent);
        elemRef.appendChild(infoBulle);
        infoPointerWrap.appendChild(infoPointer);
        elemRef.appendChild(infoPointerWrap);
        // Mobile Div part
        const infoBulleMobile = document.createElement('span');
        const infoTitleMo = document.createElement('span');
        const infoContentMo = document.createElement('span');
        const infoCloseMo = document.createElement('span');
        infoBulleMobile.setAttribute('class', 'lexicon-element__mobile');
        infoTitleMo.setAttribute('class', 'tooltip-title');
        infoContentMo.setAttribute('class', 'tooltip-content');
        infoCloseMo.setAttribute('class', 'info-close');
        infoTitleMo.innerHTML = titleTooltip;
        infoContentMo.innerHTML = contentTooltip;
        infoBulleMobile.appendChild(infoTitleMo);
        infoBulleMobile.appendChild(infoContentMo);
        infoBulleMobile.appendChild(infoCloseMo);
        descDiv.appendChild(infoBulleMobile);
        elemRef.addEventListener('click', (e) => {
          e.preventDefault();
          infoBulleMobile.classList.add('clicked');
        });
        infoCloseMo.addEventListener('click',
          (e) => {
            e.preventDefault();
            infoBulleMobile.classList.remove('clicked');
          });
      }
    });
  });
};

export default createInfoBulle;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/InfoBulle.js